import React from 'react';

const KolaborasiRemixKomunitasScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Salah satu fitur paling revolusioner di ekosistem Scratch adalah tombol <b>&quot;Remix&quot;</b>. Fitur ini memungkinkan setiap pengguna di seluruh dunia untuk melihat susunan blok kode di balik proyek pengguna lain, memodifikasinya, dan mempublikasikannya kembali dengan mencantumkan kredit kepada pembuat aslinya secara otomatis.
      </p>

      <p className="mb-4">
        Di tengah budaya digital yang sering kali memandang proses belajar sebagai kompetisi tertutup, fitur Remix mengajarkan nilai keterbukaan (<i>Open Source Philosophy</i>), kerja sama, dan etika atribusi karya sejak usia dini.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Belajar dengan Menelaah Kode Nyata (Reverse Engineering)
      </h2>
      <p className="mb-4">
        Ketika seorang anak menyukai mekanisme game buatan orang lain—misalnya sistem skor berganda atau animasi partikel yang indah—mereka tidak perlu menebak-nebak bagaimana cara membuatnya. Dengan membuka proyek tersebut, anak dapat mempelajari susunan logika blok secara langsung, mengujinya per bagian, lalu mengembangkannya dengan ide kreatif mereka sendiri.
      </p>

      <div className="bg-purple-50 border-l-4 border-purple-300 p-4 mb-4 rounded-r-lg">
        <p className="text-gray-800 text-sm">
          <b>&quot;Remix bukan tentang menjiplak, melainkan tentang berdiri di atas bahu karya orang lain untuk melompat lebih tinggi dan menghadirkan inovasi baru.&quot;</b>
        </p>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Etika Komunitas: Memberi Penghargaan pada Karya Asal
      </h2>
      <p className="mb-4">
        Scratch secara ketat menanamkan kesadaran hak cipta dan penghargaan intelektual. Setiap proyek hasil remix akan menampilkan silsilah pohon keluarga proyek (<i>Remix Tree</i>) di halaman deskripsinya, memastikan bahwa kontribusi pembuat kode awal selalu diakui dan diapresiasi oleh komunitas.
      </p>

      <p className="mb-4">
        Kekuatan komunitas yang saling mendukung dan terbuka inilah yang menjadikan Scratch bukan sekadar alat belajar koding, melainkan taman bermain digital global tempat jutaan anak di dunia saling menginspirasi dan tumbuh bersama.
      </p>
    </div>
  );
};

export default KolaborasiRemixKomunitasScratch;
